import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=5095c342&scoped=true&"
import script from "./CustomButton.vue?vue&type=script&lang=js&"
export * from "./CustomButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=5095c342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095c342",
  null
  
)

export default component.exports